import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FieldComponent} from "../../../field/field.component";
import { FormControl, FormGroup, Validators} from "@angular/forms";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {PinManagerService} from "../../../services/pin-manager.service";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import {PinType} from "../../../models/pinType";
import { Database, ref, push, set, serverTimestamp } from '@angular/fire/database';
// InspectorAssignmentComponent removed — inspector selection now handled inside FieldInspectionDialogComponent

export const PIN_ICONS = {
    1: 'marker_pin.png',
    2: 'virtual_consultant_pin.png',
    3: 'soft_tissue_pin.png',
    4: 'soil_pin.png',
    5: 'water_pin.png',
    6: 'disease_pin.png',
    7: 'pest_pin.png',
    8: 'yield_estimations_pin.png',
    9: 'Ntester_pin.png',
    10: 'field_inspection_pin.png' // Field Inspection pin
}

@Component({
    selector: 'app-new-save-pin',
    templateUrl: './new-save-pin.component.html',
    styleUrls: ['./new-save-pin.component.css'],
    standalone: false
})
export class NewSavePinComponent implements OnInit{
  saveNewPinForm: FormGroup;
  pinTypesList = [];
  newPinId: number;
  isValid: boolean = false;
  pinType: PinType;
  excludedId:number = 9; //N tester pin Id
  pinIcons = PIN_ICONS

  isSoilPin: boolean = false;
  isPinInputVisible: boolean = false;
  isVirtualConsultantPin: boolean = false;
  isMarkerPin: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<FieldComponent>,
              public dialog: MatDialog,
              private pinManagerService: PinManagerService,
              public nav: NavBarComponent,
              private db: Database,
  ) {

    // super();
    this.saveNewPinForm = new FormGroup({
      pinType: new FormControl(null, [Validators.required]),
      pinDescription: new FormControl(null, [Validators.required]),
    });

  }
  ngOnInit(): void {
    this.populatePinTypesListDropDown();
  }

  cancel() {
    this.dialogRef.close({"option": "cancel"});
  }
  removePin() {
    this.dialogRef.close({"option": "remove"});
  }
  savePin() {
    if(this.saveNewPinForm.controls?.pinType?.value?.id !== 3 && this.saveNewPinForm.controls?.pinType?.value?.id !== 4) {
        this.saveNewPinForm.markAllAsTouched();
        this.isValid = this.saveNewPinForm.valid;
    } else {
        this.isValid = true;
    }

      if(this.isValid) {
          this.pinTypesList.forEach((result) => {
              if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 1) {

                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: this.saveNewPinForm.controls.pinDescription.value,
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }
                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          console.error(error);
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });

              } else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 2) {



                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: this.saveNewPinForm.controls.pinDescription.value,
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }

                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.createInspection(response.description, response);

                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 3) {
                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: 'Soft Tissue',
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }

                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          console.error(error);
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 4) {
                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: 'Soil',
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }

                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          console.error(error);
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 5) {
                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: this.saveNewPinForm.controls.pinDescription.value,
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }

                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 6) {
                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: this.saveNewPinForm.controls.pinDescription.value,
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }

                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          console.error(error);
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 7) {
                  let selectedPin = {
                      option: 'save',
                      pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                      fieldId: this.data.fieldId,
                      userId: this.data.userId,
                      tenantId: this.data.tenantId,
                      description: this.saveNewPinForm.controls.pinDescription.value,
                      lat: this.data.lat,
                      lng: this.data.lng,
                  }
                  this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                      catchError(error => {
                          console.error(error);
                          return throwError(() => error);
                      })
                  ).subscribe((response) => {
                      let pinObj = {
                          pinMarker: response,
                          option: 'save',
                      }
                      this.dialogRef.close(pinObj);
                  });
              }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 8) {
                let selectedPin = {
                    option: 'save',
                    pinTypeId: this.saveNewPinForm.controls.pinType.value.id,
                    fieldId: this.data.fieldId,
                    userId: this.data.userId,
                    tenantId: this.data.tenantId,
                    description: this.saveNewPinForm.controls.pinDescription.value,
                    lat: this.data.lat,
                    lng: this.data.lng,
                }
                this.pinManagerService.postNewPin(selectedPin.pinTypeId, selectedPin.fieldId, selectedPin.userId, selectedPin.tenantId, selectedPin.description, selectedPin.lat, selectedPin.lng).pipe(
                    catchError(error => {
                        console.error(error);
                        return throwError(() => error);
                    })
                ).subscribe((response) => {
                    let pinObj = {
                        pinMarker: response,
                        option: 'save',
                    }
                    this.dialogRef.close(pinObj);
                });
            }
              else if (result.id === this.saveNewPinForm.controls.pinType.value.id && this.saveNewPinForm.controls.pinType.value.id == 10) {
                // Field Inspection pin — save pin then close; inspector assignment is handled
                // inside FieldInspectionDialogComponent as step 0 of the inspection flow.
                const description = 'Field Inspection';
                this.pinManagerService.postNewPin(10, this.data.fieldId, this.data.userId, this.data.tenantId, description, this.data.lat, this.data.lng).pipe(
                  catchError(error => {
                    console.error(error);
                    return throwError(() => error);
                  })
                ).subscribe((response) => {
                  this.dialogRef.close({
                    pinMarker: response,
                    option: 'save',
                    isFieldInspection: true
                  });
                });
              }
          })
      }
  }

  createInspection(desc, marker) {
  
    const dbRef = ref(this.db, 'inspections/');
    push(dbRef).then(newRef => {
        let newKey = newRef.key;
        let firebaseTimestamp = serverTimestamp();
        // let dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

        let inspection = {
            description: desc,
            farmName: this.data.farm,
            fieldName: this.data.field,
            key: newKey,
            lastUpdated: firebaseTimestamp,
            latitude: String(marker.lat),
            longitude: String(marker.lng),
            sender: String(marker.userId),
            tenantId: String(marker.tenantId)
        };
        set(newRef, inspection);
    });
}






    onPinTypeSelection(selectedVal:any) {
          this.pinType = selectedVal.value;
          this.saveNewPinForm.controls.pinDescription.setValue('');
          if (selectedVal.value.id == 3 || selectedVal.value.id == 4) {
              this.isPinInputVisible = false;
          }else{
              this.isPinInputVisible = true;
          }
    }

  //// DROP DOWN ////
  populatePinTypesListDropDown() {
    this.pinManagerService.getPinTypesList().pipe(
            catchError((error) => {
              console.error(error);
              return throwError(() => error);
            })
        )
        .subscribe((response) => {
          this.pinTypesList = response;
          this.pinTypesList = this.pinTypesList.filter(item => item.id !== this.excludedId);

          // Field Inspection (id=10) requires InspectionRequestor role
          const roles = JSON.parse(sessionStorage.getItem('roles') || '[]');
          const hasInspectionRequestorRole = roles.some((r: any) => r.name === 'InspectionRequestor');
          if (!hasInspectionRequestorRole) {
            this.pinTypesList = this.pinTypesList.filter(item => item.id !== 10);
          }
        });
        this.nav.toggleLoading(false);
  }

}
